import { API_BASE_URL, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function uploadFile(obj) {
    try {
        let data = null;
        const { code, body } = await fetch(
            API_BASE_URL + "/upload-file/upload-file",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
        }
        return data;
    } catch (err) {
        console.log("uploadFile err");
        console.log(err);
        return null;
    }
}